import { render, staticRenderFns } from "./disciple.vue?vue&type=template&id=5b897b15&"
import script from "./disciple.vue?vue&type=script&lang=js&"
export * from "./disciple.vue?vue&type=script&lang=js&"
import style0 from "./disciple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b897b15')) {
      api.createRecord('5b897b15', component.options)
    } else {
      api.reload('5b897b15', component.options)
    }
    module.hot.accept("./disciple.vue?vue&type=template&id=5b897b15&", function () {
      api.rerender('5b897b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/disciple.vue"
export default component.exports